'use client';

import AppImage from '@/components/ui/AppImage';
import Link from 'next/link';

interface ProjectCardProps {
  project: {
    id: number;
    title: string;
    category: string;
    year: number;
    image: string;
    alt: string;
    description: string;
    client: string;
    results?: string[];
  };
  onClick: () => void;
}

const ProjectCard = ({ project, onClick }: ProjectCardProps) => {
  // Map project titles to routes
  const getProjectRoute = (title: string): string => {
    const routeMap: { [key: string]: string } = {
      'Structural System Parts': '/mechanical-parts',
      'Electrical System Parts': '/electrical-parts',
      'Power System Parts': '/power-parts',
      'Cabs & Gates': '/cabs-gates',
    };
    return routeMap[title] || '/portfolio';
  };

  return (
    <div className="group">
      <div className="relative overflow-hidden bg-card aspect-[4/5] border-2 border-black">
        <AppImage
          src={project.image}
          alt={project.alt}
          className="w-full h-full object-cover transition-transform duration-slow group-hover:scale-105"
        />
      </div>
      <div className="mt-4 text-center">
        <h3 className="text-lg font-headline font-bold text-primary mb-4">
          {project.title}
        </h3>
        <Link
          href={getProjectRoute(project.title)}
          className="inline-block bg-primary text-primary-foreground px-6 py-3 rounded-lg font-body font-semibold hover:bg-primary/90 transition-colors"
        >
          View Parts
        </Link>
      </div>
    </div>
  );
};

export default ProjectCard;